import { goto } from '$app/navigation';
import { PAGES } from '$lib/utils/constants';

/**
 * Internal giveaway CTA platform keys (not exported).
 * @typedef {'AMAZON'|'GOOGLE'|'IOS'|'SAMSUNG'|'WEB'} GiveawayPlatform
 */
/** @type {Record<GiveawayPlatform, () => Promise<void>>} */
const PLATFORM_BEHAVIOR = {
	AMAZON: async () => {
		// future: implement when PLATFORM_CONDITION includes AMAZON
	},
	GOOGLE: async () => {
		// future: implement when PLATFORM_CONDITION includes GOOGLE
	},
	IOS: async () => {
		// future: implement when PLATFORM_CONDITION includes IOS
	},
	SAMSUNG: async () => {
		// future: implement when PLATFORM_CONDITION includes SAMSUNG
	},
	WEB: async () => {
		await goto(PAGES.INTERNAL.SUBSCRIPTION);
	},
};

/**
 * One row in {@link PLATFORM_CONDITION} (first matching `condition` wins).
 * @typedef {object} PlatformConditionEntry
 * @property {() => boolean} condition - First truthy match wins (order matters for overlapping conditions).
 * @property {GiveawayPlatform} platform
 */
/** @type {PlatformConditionEntry[]} */
const PLATFORM_CONDITION = [
	// future: { condition: () => /* ios */, platform: 'IOS' },
	// future: { condition: () => /* amazon */, platform: 'AMAZON' },
	// future: { condition: () => /* samsung */, platform: 'SAMSUNG' },
	// future: { condition: () => /* google/android */, platform: 'GOOGLE' },
	{ condition: () => true, platform: 'WEB' },
];

/**
 * Giveaway CTA behavior — resolves platform and runs the matching handler (for `signUpCallback` on nav).
 */
export class GiveawayService {
	/**
	 * Evaluates `PLATFORM_CONDITION` top-to-bottom; returns the first matching platform.
	 * @returns {GiveawayPlatform}
	 */
	static resolvePlatform() {
		const entry = PLATFORM_CONDITION.find((e) => e.condition());

		return entry?.platform ?? 'WEB';
	}

	/**
	 * No-arg callback for `NavButtonsRebrand` `signUpCallback` (awaited by the component).
	 * @returns {Promise<void>}
	 */
	static async signUpCallback() {
		const platform = GiveawayService.resolvePlatform();
		const handler = PLATFORM_BEHAVIOR[platform];

		await handler();
	}
}
